import {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import _ from 'lodash';
import {useSelector} from 'react-redux';
import {useAuth} from '../../../modules/auth';
import {Tabs, Form, Input, Select, Spin, notification, DatePicker} from 'antd';
import ImageUpload from 'src/app/components/ImageUpload';
import {handleImage} from 'src/utils/utils';
import locale from 'antd/es/date-picker/locale/vi_VN';
import {
  requestPOST,
  requestPOST_NEW,
  requestGET,
  requestPUT_NEW,
  API_URL,
  FILE_URL,
} from 'src/utils/baseAPI';
import * as authHelper from 'src/app/modules/auth/core/AuthHelpers';
import moment from 'moment';
import {toast} from 'react-toastify';
import ChangePassword from './ChangePassword';
import {useIntl} from 'react-intl';

const Profile = () => {
  const {currentUser} = useAuth();
  const {token} = authHelper.getAuth();

  const [form] = Form.useForm();

  const FormItem = Form.Item;
  const {Option} = Select;
  const intl = useIntl();

  const genders = [
    {id: 'Nam', name: intl.formatMessage({id: 'GENDER.MALE'})},
    {id: 'Nữ', name: intl.formatMessage({id: 'GENDER.FEMALE'})},
    {id: 'Khác', name: intl.formatMessage({id: 'GENDER.OTHER'})},
  ];
  const [loadding, setLoadding] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [communes, setCommunes] = useState([]);
  const [branches, setBranches] = useState([]);

  const [provinceId, setProvinceId] = useState(null);
  const [districtId, setDistrictId] = useState(null);
  const [image, setImage] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);

  const [tabActive, setTabActive] = useState('1');
  const changeTab = (key) => {
    setTabActive(key);
  };
// console.log(currentUser)
  useEffect(() => {
    const fetchData = async () => {
      const res = await requestPOST(`api/v1/areas/search`, {
        pageNumber: 1,
        pageSize: 1000,
        orderBy: ['name'],
        level: 1,
      });
      if (res && res.data) setProvinces(res.data);
    };
    fetchData();

    form.setFieldsValue(currentUser);
    setProvinceId(currentUser?.provinceId ?? null);
    setDistrictId(currentUser?.districtId ?? null);
    setImage(handleImage(currentUser?.imageUrl ?? '', FILE_URL));
    if (currentUser.dateOfBirth) {
      form.setFieldsValue({dateOfBirth: moment(currentUser?.dateOfBirth)});
    }
    return () => {};
  }, []);

  useEffect(() => {
    const fetchData = () => {
      var myHeaders = new Headers();
      myHeaders.append('Accept', 'application/json');
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('tenant', 'root');

      var raw = JSON.stringify({
        pageNumber: 1,
        pageSize: 1000,
        orderBy: ['name'],
        level: 1,
      });

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };

      fetch('http://root.hanhchinhcong.org/api/v1/areas/search', requestOptions)
        .then((response) => response.json())
        .then((result) => {
          // console.log(result);
          if (result && result.data) setProvinces(result.data);
        })
        .catch((error) =>  console.log('error', error));
    };
    fetchData();
    return () => {};
  }, []);

  useEffect(() => {
    if (provinceId) {
      const fetchData = () => {
        var myHeaders = new Headers();
        myHeaders.append('Accept', 'application/json');
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('tenant', 'root');

        var raw = JSON.stringify({
          pageNumber: 1,
          pageSize: 1000,
          orderBy: ['name'],
          parentId: provinceId,

          level: 2,
        });

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        };

        fetch('http://root.hanhchinhcong.org/api/v1/areas/search', requestOptions)
          .then((response) => response.json())
          .then((result) => {
            // console.log(result);
            if (result && result.data) setDistricts(result.data);
          })
          .catch((error) =>  console.log('error', error));
      };
      fetchData();
    }
    return () => {};
  }, [provinceId]);

  useEffect(() => {
    if (districtId) {
      const fetchData = () => {
        var myHeaders = new Headers();
        myHeaders.append('Accept', 'application/json');
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('tenant', 'root');

        var raw = JSON.stringify({
          pageNumber: 1,
          pageSize: 1000,
          orderBy: ['name'],
          level: 3,
          parentId: districtId,
        });

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        };

        fetch('http://root.hanhchinhcong.org/api/v1/areas/search', requestOptions)
          .then((response) => response.json())
          .then((result) => {
            // console.log(result);
            if (result && result.data) setCommunes(result.data);
          })
          .catch((error) =>  console.log('error', error));
      };

      fetchData();
    }
    return () => {};
  }, [districtId]);

  const saveChange = async () => {
    setButtonLoading(true);
    try {
      const formData = form.getFieldsValue(true);
      const formData2 = (({
        userName,
        fullName,
        phoneNumber,
        email,
        gender,
        placeOfOrigin,
        identityDate,
        identityPlace,
        placeOfDestination,
        nationality,
        identityNumber,
        dateOfBirth,
        imageUrl,
        address,
        communeId,
        districtId,
        provinceId,
        branchIds,
      }) => ({
        userName,
        fullName,
        phoneNumber,
        email,
        gender,
        placeOfOrigin,
        identityDate,
        identityPlace,
        placeOfDestination,
        nationality,
        identityNumber,
        dateOfBirth,
        imageUrl,
        address,
        communeId,
        districtId,
        provinceId,
        branchIds,
      }))(formData);
      // console.log(formData2);

      if (image.length > 0) {
        formData.imageUrl = image[0]?.response?.data[0]?.url ?? image[0].path;
      } else {
        formData.imageUrl = null;
      }

      const res = await requestPUT_NEW(`api/personal/profile`, formData2);
      if (res) {
        toast.success(intl.formatMessage({id: 'LOG.UPDATESUCESSFUL'}));
      } else {
        //toast.error('Thất bại, vui lòng thử lại!');
        const errors = Object.values(res?.data?.errors ?? {});
        let final_arr = [];
        errors.forEach((item) => {
          final_arr = _.concat(final_arr, item);
        });
        // console.log(final_arr);
        toast.error(intl.formatMessage({id: 'LOG.UPDATEFAILED'}) + final_arr.join(' '));
      }
    } catch (err) {}

    setButtonLoading(false);
  };
  return (
    <>
      <div className='app-main flex-column flex-row-fluid bg-white'>
        <div className='d-flex flex-column flex-column-fluid'>
          <div id='kt_app_toolbar' className='app-toolbar py-3 py-lg-6 mx-5'>
            <div
              id='kt_app_toolbar_container'
              className='app-container container d-flex flex-stack'
            >
              <div className='page-title d-flex flex-column justify-content-center flex-wrap me-3'>
                <h1 className='page-heading d-flex text-dark fw-bold fs-0 flex-column justify-content-center my-0'>
                  {intl.formatMessage({id: 'USER.ACCOUNT'})}
                </h1>
                <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1'>
                  <li className='breadcrumb-item text-muted '>
                    
                    <Link to='/system' className='text-muted text-hover-primary'>
                      {intl.formatMessage({id: 'MENU.HOMEPAGE'})}
                    </Link>
                  </li>
                  <li className='breadcrumb-item'>
                    <span className='bullet bg-gray-400 w-5px h-2px'></span>
                  </li>
                  <li className='breadcrumb-item text-muted'>{intl.formatMessage({id: 'USER.ACCOUNT'})}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* end header  */}
          <div className='app-content flex-column-fluid'>
            <div className='app-container container-xxl '>
              <div className='card mb-5 mb-xl-10 pt-xxl-3'>
                <div className='card-body pt-9 pb-0'>
                  <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                    <div className='me-7 mb-4'>
                      <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                        <img
                          src={
                            currentUser?.imageUrl != null
                              ? API_URL + '/' + currentUser?.imageUrl
                              : 'https://preview.keenthemes.com/metronic8/demo1/assets/media/avatars/300-1.jpg'
                          }
                          alt='image'
                        />
                        <div className='position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px'></div>
                      </div>
                    </div>
                    <div className='flex-grow-1'>
                      <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                        <div className='d-flex flex-column'>
                          <div className='d-flex align-items-center mb-2'>
                            <a
                              href='#'
                              className='text-gray-900 text-hover-primary fs-2 fw-bold me-1'
                            >
                              {currentUser?.userName}
                            </a>
                            <a href='#'>
                              <span className='svg-icon svg-icon-1 svg-icon-primary'>
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='24px'
                                  height='24px'
                                  viewBox='0 0 24 24'
                                >
                                  <path
                                    d='M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z'
                                    fill='currentColor'
                                  ></path>
                                  <path
                                    d='M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z'
                                    fill='white'
                                  ></path>
                                </svg>
                              </span>
                            </a>
                            {/* <a
                              href='#'
                              className='btn btn-sm btn-light-success fw-bold ms-2 fs-8 py-1 px-3'
                              data-bs-toggle='modal'
                              data-bs-target='#kt_modal_upgrade_plan'
                            >
                              nâng cấp vip
                            </a> */}
                          </div>
                          <div className='d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2'>
                            {currentUser?.fullName && (
                              <div className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                                <span className='svg-icon svg-icon-4 me-1'>
                                  <svg
                                    width='18'
                                    height='18'
                                    viewBox='0 0 18 18'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      opacity='0.3'
                                      d='M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z'
                                      fill='currentColor'
                                    ></path>
                                    <path
                                      d='M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z'
                                      fill='currentColor'
                                    ></path>
                                    <rect
                                      x='7'
                                      y='6'
                                      width='4'
                                      height='4'
                                      rx='2'
                                      fill='currentColor'
                                    ></rect>
                                  </svg>
                                </span>
                                {`${currentUser?.fullName}`}
                              </div>
                            )}

                            {currentUser?.email && (
                              <div className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'>
                                <span className='svg-icon svg-icon-4 me-1'>
                                  <svg
                                    width='24'
                                    height='24'
                                    viewBox='0 0 24 24'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      opacity='0.3'
                                      d='M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z'
                                      fill='currentColor'
                                    ></path>
                                    <path
                                      d='M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z'
                                      fill='currentColor'
                                    ></path>
                                  </svg>
                                </span>
                                {currentUser?.email}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Tabs activeKey={tabActive} onChange={changeTab}>
                    <Tabs.TabPane tab={intl.formatMessage({id: 'MENU.OVERVIEW'})} key='1'>
                      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
                        <div className='card-header cursor-pointer'>
                          <div className='card-title m-0'>
                            <h3 className='fw-bold m-0'>{intl.formatMessage({id: 'ACCOUNT.INFO'})}</h3>
                          </div>
                          <button
                            onClick={() => changeTab('2')}
                            className='btn btn-primary align-self-center'
                          >
                            {intl.formatMessage({id: 'MENU.EDIT'})}{' '}
                          </button>
                        </div>

                        <div className='card-body p-9'>
                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-semibold text-muted'>{intl.formatMessage({id: 'USER.FULLNAME'})}</label>
                            <div className='col-lg-8'>
                              <span className='fw-bold fs-6 text-gray-800'>
                                {currentUser?.fullName}
                              </span>
                            </div>
                          </div>

                          {/* <div className='row mb-7'>
                            <label className='col-lg-4 fw-semibold text-muted'>Chi nhánh</label>

                            <div className='col-lg-8 fv-row'>
                              <span className='fw-semibold text-gray-800 fs-6'>
                                {currentUser?.branches[0]?.name}
                              </span>
                            </div>
                          </div> */}

                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-semibold text-muted'>
                              {intl.formatMessage({id: 'USER.PHONE'})}
                              <i
                                className='fas fa-exclamation-circle ms-1 fs-7'
                                data-bs-toggle='tooltip'
                                aria-label='Phone number must be active'
                                data-bs-original-title='Phone number must be active'
                                data-kt-initialized='1'
                              ></i>
                            </label>
                            <div className='col-lg-8 d-flex align-items-center'>
                              <span className='fw-bold fs-6 text-gray-800 me-2'>
                                {currentUser?.phoneNumber}
                              </span>
                            </div>
                          </div>

                          <div className='row mb-7'>
                            <label className='col-lg-4 fw-semibold text-muted'>{intl.formatMessage({id: 'USER.EMAIL'})}</label>

                            <div className='col-lg-8'>
                              <a
                                href='#'
                                className='fw-semibold fs-6 text-gray-800 text-hover-primary'
                              >
                                {currentUser?.email}
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>{' '}
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={intl.formatMessage({id: 'MENU.SETTINGS'})} key='2'>
                      <div className='card mb-5 mb-xl-10'>
                        <div
                          className='card-header border-0 cursor-pointer'
                          role='button'
                          data-bs-toggle='collapse'
                          data-bs-target='#kt_account_profile_details'
                          aria-expanded='true'
                          aria-controls='kt_account_profile_details'
                        >
                          <div className='card-title m-0'>
                            <h3 className='fw-bold m-0'>{intl.formatMessage({id: 'ACCOUNT.INFO'})}</h3>
                          </div>
                        </div>

                        <div id='kt_account_settings_profile_details' className='collapse show'>
                          <form
                            id='kt_account_profile_details_form'
                            className='form fv-plugins-bootstrap5 fv-plugins-framework'
                            noValidate='novalidate'
                          >
                            <div className='card-body border-top p-9'>
                              <Form
                                form={form}
                                layout='vertical'
                                /* initialValues={initData} */ autoComplete='off'
                              >
                                <div className='row '>
                                  <div className=' col-xl-4 col-lg-6'>
                                    <FormItem label={intl.formatMessage({id: 'USER.AVATAR'})}>
                                      <ImageUpload
                                        URL={`${API_URL}/api/v1/attachments/attachmentserver`}
                                        fileList={image}
                                        onChange={(e) => setImage(e.fileList)}
                                        headers={{
                                          Authorization: `Bearer ${token}`,
                                        }}
                                      />
                                    </FormItem>
                                  </div>
                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem
                                      label={intl.formatMessage({id: 'USER.FULLNAME'})}
                                      name='fullName'
                                      rules={[{required: true, message:intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED_FIELD'})}]}
                                    >
                                      <Input placeholder={intl.formatMessage({id: 'USER.FULLNAME'})} />
                                    </FormItem>
                                  </div>

                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem
                                      label={intl.formatMessage({id: 'USER.EMAIL'})}
                                      name='email'
                                      rules={[
                                        {required: true, message: intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED_FIELD'})},
                                        {
                                          pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                          message:
                                            intl.formatMessage({id: 'AUTH.VALIDATION.INVALID_FIELD'}),
                                        },
                                      ]}
                                    >
                                      <Input placeholder='' />
                                    </FormItem>
                                  </div>
                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem label={intl.formatMessage({id: 'USER.GENDER'})} name='gender'>
                                      <Select
                                        showSearch
                                        placeholder={intl.formatMessage({id: 'USER.GENDER'})}
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                      >
                                        {genders.map((item) => {
                                          return (
                                            <Option key={item.id} value={item.id}>
                                              {item.name}
                                            </Option>
                                          );
                                        })}
                                      </Select>
                                    </FormItem>
                                  </div>

                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem label={intl.formatMessage({id: 'USER.DOB'})} name='dateOfBirth'>
                                      <DatePicker
                                        locale={locale}
                                        format='DD/MM/YYYY'
                                        style={{width: '100%'}}
                                        placeholder={intl.formatMessage({id: 'USER.DOB'})}
                                      />
                                    </FormItem>
                                  </div>
                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem
                                      label={intl.formatMessage({id: 'USER.PHONE'})}
                                      name='phoneNumber'
                                      rules={[
                                        {required: true, message: intl.formatMessage({id: 'AUTH.VALIDATION.REQUIRED_FIELD'})},
                                        {
                                          pattern: /^(0?)(3[2-9]|5[6|8|9]|7[0|6-9]|8[0-6|8|9]|9[0-4|6-9])[0-9]{7}$/,
                                          message:
                                            intl.formatMessage({id: 'AUTH.VALIDATION.INVALID_FIELD'}),
                                        },
                                      ]}
                                    >
                                      <Input placeholder='' />
                                    </FormItem>
                                  </div>
                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem label={intl.formatMessage({id: 'USER.DOCUMENTNUMBER'})} name='identityNumber'>
                                      <Input placeholder='' />
                                    </FormItem>
                                  </div>
                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem label={intl.formatMessage({id: 'USER.ISSUEDATE'})} name='identityDateOfIssue'>
                                      <DatePicker
                                        locale={locale}
                                        format='DD/MM/YYYY'
                                        style={{width: '100%'}}
                                        placeholder={intl.formatMessage({id: 'USER.ISSUEDATE'})}
                                      />
                                    </FormItem>
                                  </div>
                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem label={intl.formatMessage({id: 'USER.ISSUELOCATION'})} name='identityPlace'>
                                      <Input placeholder='' />
                                    </FormItem>
                                  </div>

                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem label={intl.formatMessage({id: 'USER.ADDRESS.CITY'})} name='provinceId'>
                                      <Select
                                        allowClear
                                        showSearch
                                        placeholder={intl.formatMessage({id: 'USER.ADDRESS.CITY'})}
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                        onChange={(val) =>
                                          setProvinceId(val) +
                                          form.resetFields(['districtId', 'communeId'])
                                        }
                                      >
                                        {provinces.map((item) => {
                                          return (
                                            <Option key={item.id} value={item.id}>
                                              {item.nameWithType}
                                            </Option>
                                          );
                                        })}
                                      </Select>
                                    </FormItem>
                                  </div>

                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem label={intl.formatMessage({id: 'USER.ADDRESS.DISTRICT'})} name='districtId'>
                                      <Select
                                        allowClear
                                        showSearch
                                        placeholder={intl.formatMessage({id: 'USER.ADDRESS.DISTRICT'})}
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                        onChange={(val) =>
                                          setDistrictId(val) + form.resetFields(['communeId'])
                                        }
                                      >
                                        {districts.map((item) => {
                                          return (
                                            <Option key={item.id} value={item.id}>
                                              {item.nameWithType}
                                            </Option>
                                          );
                                        })}
                                      </Select>
                                    </FormItem>
                                  </div>
                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem label={intl.formatMessage({id: 'USER.ADDRESS.SUBDISTRICT'})} name='communeId'>
                                      <Select
                                        allowClear
                                        showSearch
                                        placeholder={intl.formatMessage({id: 'USER.ADDRESS.SUBDISTRICT'})}
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                      >
                                        {communes.map((item) => {
                                          return (
                                            <Option key={item.id} value={item.id}>
                                              {item.nameWithType}
                                            </Option>
                                          );
                                        })}
                                      </Select>
                                    </FormItem>
                                  </div>
                                  <div className='col-xl-4 col-lg-6'>
                                    <FormItem label={intl.formatMessage({id: 'USER.ADDRESS'})} name='address'>
                                      <Input placeholder={intl.formatMessage({id: 'USER.ADDRESS'})} />
                                    </FormItem>
                                  </div>
                                  
                                  {/* <div className='col-xl-4 col-lg-6'>
                            <FormItem label='Chi nhánh' name='branchIds'>
                              <Select
                                mode='multiple'
                                allowClear
                                showSearch
                                placeholder='Chi nhánh'
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {branches.map((item) => {
                                  return (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </FormItem>
                          </div> */}
                                </div>
                              </Form>
                            </div>

                            <div className='card-footer d-flex justify-content-end py-6 px-9'>
                              <button
                                type='button'
                                className='btn btn-primary'
                                id='kt_account_profile_details_submit'
                                onClick={saveChange}
                                disabled={buttonLoading}
                              >
                                {intl.formatMessage({id: 'BTN.SAVE'})}
                              </button>
                            </div>
                            <input type='hidden' />
                          </form>
                        </div>
                      </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane key='3' tab={intl.formatMessage({id: 'MENU.CHANGEPASSWORD'})}>
                      <ChangePassword />
                    </Tabs.TabPane>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
          {/* end tab */}
        </div>
      </div>
    </>
  );
};

export default Profile;
